import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { RouterView } from 'vue-router'
import PrivacyPolicyLink from '@/components/PrivacyPolicyLink.vue'
import ImprintLink from '@/components/ImprintLink.vue'
import CookieLink from '@/components/CookieLink.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLayoutDefault',
  setup(__props) {

const isFooterOverflow = computed(() => !useRoute().path.includes('sennfuel'))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(RouterView), { class: "dsf-theme-default" }),
    _createElementVNode("footer", {
      class: _normalizeClass(["flex h-35 border-t-1 border-neutral-100 py-8 items-center gap-16 justify-center bg-neutral-0", {
        'footer absolute z-10 w-[50%] bottom-0 left-[50%]': isFooterOverflow.value,
      }])
    }, [
      _createVNode(PrivacyPolicyLink),
      _createVNode(ImprintLink),
      _createVNode(CookieLink)
    ], 2 /* CLASS */)
  ]))
}
}

})